module.exports = __webpack_public_path__ + "static/img/connectionInProgress.c1ecf46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connectionInProgress.png
// module id = 673
// module chunks = 8